import { Suspense, useEffect } from "react";
import { routes } from "./hooks/routes";
import { Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { AvatarProvider } from "./context/AvatarContext";
import { CountryProvider } from "./context/CountryContext";
import { LanguageProvider } from "./context/LanguageContext";
import LoadingSpinner from "./components/common/LoadingSpinner";
import { RoomProvider } from "./context/RoomContext";
import { DiaryRoomProvider } from "./context/DiaryRoomContext";
import { EmotionRoomProvider } from "./context/EmotionRoomContext";
import { FamilyTreeRoomProvider } from "./context/FamilyTreeRoomContext";
import { useAuth } from "./context/AuthContext";
import { useLanguage } from "./context/LanguageContext";
import ChildProfileIcon from "./components/common/ChildProfileIcon";
import CoinCelebration from "./components/common/CoinCelebration";

const AUTH_ROUTES = ["/", "/auth/register/child", "/auth/register/adult"];

function AppContent() {
  const { user } = useAuth();
  const { setLanguage } = useLanguage();
  const location = useLocation();

  // Al hacer login, aplicar el idioma del perfil SOLO si no hay preferencia local guardada
  useEffect(() => {
    if (user?.language && !localStorage.getItem("appLanguage")) {
      setLanguage(user.language);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id]);

  return (
    <>
      {user?.rol === "child" && !AUTH_ROUTES.includes(location.pathname) && <ChildProfileIcon />}
      <CoinCelebration />
      <Suspense fallback={<LoadingSpinner />}>
        <Routes>
          {routes.map((route) => (
            <Route
              key={route.path}
              path={route.path}
              element={route.element}
            />
          ))}
        </Routes>
      </Suspense>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <CountryProvider>
          <AvatarProvider>
            <RoomProvider>
              <DiaryRoomProvider>
                <EmotionRoomProvider>
                  <FamilyTreeRoomProvider>
                    <AppContent />
                  </FamilyTreeRoomProvider>
                </EmotionRoomProvider>
              </DiaryRoomProvider>
            </RoomProvider>
          </AvatarProvider>
        </CountryProvider>
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
